import { Box, Button } from '@mui/material'
import { Link } from 'react-router-dom'
import { ButtonCountdown } from '../../sharedComponents/src/globalHeader/components/ButtonCountdown'
import { useScreenSize } from '../../sharedComponents/src/hooks/useScreenSize'
import { useStoreActions, useStoreState } from '../../store/hooks'
import { MissionsIcon } from './assets/MissionsIcon'

export const MissionsButton = () => {
    const { isMobile } = useScreenSize()
    const isCompletedMissions = useStoreState((state) => state.missionsService.isCompletedMissions)
    const nextMultiplierExpiresAt = useStoreState((state) => state.missionsService.nextMultiplierExpiresAt)

    const getMissions = useStoreActions((state) => state.missionsService.getMissions)

    return (
        <Box sx={{ position: 'relative' }}>
            <Link to="/profile/missions?tab=missions">
                {isMobile ? (
                    <Button
                        animated={Boolean(isCompletedMissions)}
                        badge={isCompletedMissions}
                        endIcon={<MissionsIcon />}
                        color="secondary"
                        size="medium"
                        variant="contained"
                        onlyIcon
                    />
                ) : (
                    <Button
                        animated={Boolean(isCompletedMissions)}
                        badge={isCompletedMissions}
                        endIcon={<MissionsIcon />}
                        color="secondary"
                        variant="contained"
                        size="large"
                    >
                        Missions
                    </Button>
                )}
            </Link>
            <ButtonCountdown resetDate={nextMultiplierExpiresAt} callback={getMissions} />
        </Box>
    )
}
